<template>
    <section id="why-choose-us" class="why-choose-us-area different-bg" v-if="pageData.length">
        <div class="container">
            <SectionContent :title="pageData.title" :subHeading="pageData.subheading" /> 

            <!-- Why Choose Wrapper-->
            <div class="why-choose-wrapper">
                
                <div class="row single-choose-box" v-for="(data, index) of fetchData" :key="index">
                   
                    <div class="col-12 col-sm-12 col-md-6">
                        <div class="why-choose-content-box">
                            <h4>{{ data.heading }}</h4>
                            <div v-html="data.content"></div>
                        </div>
                    </div>
                    <div class="col-12 col-sm-12 col-md-6">
                        <vue-aos animation-class="fadeInRight animated" :threshold="0.3">
                            <div class="why-choose-image-box position-relative ">
                                <img :src="`${baseURL}/img/why-choose-us-img/${(index > backgroundSVG.length) ? backgroundSVG[index - backgroundSVG.length] : backgroundSVG[index]}`" class="why-choose-bg-shape" alt="b">
                                <img :src="`${filePath}/${data.image_name}`" class="why-choose-img position-absolute" :alt="data.heading">
                            </div>
                        </vue-aos>
                    </div>
                </div>
         
            </div>
            <!-- Why Choose Wrapper-->
        </div>
    </section>
</template>

<script>
import VueAos from 'vue-aos'
import SectionContent from '../components/Section-Content'

export default {
    components: { VueAos, SectionContent },
    data(){
        return {
            baseURL: this.base_url,
            fetchData: [],
            filePath: '',
            limit: 4,
            backgroundSVG : [
                '1-of-1.svg',
                '2-of-2.svg', 
                '3-of-3.svg', 
                '4-of-4.svg'
            ],
            pageData: []
        }
    },
    methods: {
        async getData(){
            let params = {
                limit: this.limit
            }
            this.$http.get(`/why-choose-us`, { params }).then(res=>{                
                if(res.status === 200 && res.data.result){
                    this.fetchData = res.data.result
                    this.filePath = res.data.file_path
                    this.pageData = res.data.page_data
                }
            })
        }
    },
    created: function(){
        this.getData()
        
    }
}
</script>